import { Component } from '@angular/core';

// Wrapper for the fleet status dashboard modal shown on the map.
@Component({
  selector: 'fleet-status-modal',
  templateUrl: './fleet-status-modal.component.html',
})
export class FleetStatusModalComponent {}
